export const MOM_IFRAME_INIT = 'mom-vue3:iframe-init'
export const MOM_IFRAME_READY = 'mom-vue3:iframe-ready'
export const MOM_IFRAME_MOUNTED = 'mom-vue3:iframe-mounted'
export const MOM_IFRAME_ERROR = 'mom-vue3:iframe-error'
export const MOM_IFRAME_AUTH_EXPIRED = 'mom-vue3:iframe-auth-expired'
export const MOM_IFRAME_NAVIGATE = 'mom-vue3:iframe-navigate'

export function createMomIframeInitMessage (sessionKey, adminToken, bootstrap) {
  return {
    type: MOM_IFRAME_INIT,
    sessionKey: normalizeSessionKey(sessionKey),
    adminToken: normalizeSessionKey(adminToken),
    ...(bootstrap ? { bootstrap } : {})
  }
}

function normalizePath (path) {
  if (typeof path !== 'string' || !path.startsWith('/') || path.startsWith('//')) {
    return null
  }
  return path.replace(/\/+$/, '') || '/'
}

function isPlainObject (value) {
  return value === undefined || (
    value !== null &&
    typeof value === 'object' &&
    !Array.isArray(value)
  )
}

function stringifyQuery (query) {
  const pairs = []
  Object.keys(query).forEach(key => {
    const values = Array.isArray(query[key]) ? query[key] : [query[key]]
    values.forEach(value => {
      if (value === undefined) return
      pairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(value == null ? '' : value)}`)
    })
  })
  return pairs.join('&')
}

export function buildMomVue3Url (baseUrl, outerLink, routeQuery) {
  const target = String(outerLink || '').trim()
  const base = String(baseUrl || '').split(/[?#]/, 1)[0].replace(/\/+$/, '')
  const query = { ...(routeQuery || {}) }
  delete query.prePath
  query.subapp = 1
  const queryString = stringifyQuery(query)
  if (/^https?:\/\//i.test(target)) {
    const url = new URL(target)
    Object.keys(query).forEach(key => {
      url.searchParams.delete(key)
      const values = Array.isArray(query[key]) ? query[key] : [query[key]]
      values.forEach(value => {
        if (value !== undefined) {
          url.searchParams.append(key, value == null ? '' : value)
        }
      })
    })
    return url.toString()
  }
  const path = `/${target.replace(/^\/+/, '')}`
  return `${base}${path}?${queryString}`
}

export function isTrustedMomVue3Url (frameUrl, baseUrl, pageUrl) {
  try {
    if (!frameUrl || !baseUrl || !pageUrl) return false
    const page = new URL(pageUrl)
    const frame = new URL(frameUrl, page)
    const configuredBase = new URL(
      String(baseUrl).split(/[?#]/, 1)[0],
      page
    )
    return frame.origin === configuredBase.origin
  } catch (error) {
    return false
  }
}

export function normalizeSessionKey (sessionKey) {
  return typeof sessionKey === 'string' ? sessionKey : ''
}

export function formatMomLoadError (stage, url) {
  return `${stage || 'MOM 加载'}超时：${url}`
}

function flattenRoutes (routes, result) {
  const output = result || []
  ;(Array.isArray(routes) ? routes : []).forEach(route => {
    output.push(route)
    flattenRoutes(route.children, output)
  })
  return output
}

function copyNavigationData (request, location) {
  if (request.params !== undefined) location.params = request.params
  if (request.query !== undefined) location.query = request.query
  return location
}

export function findAllowedNavigation (routes, request) {
  if (!request || !isPlainObject(request.params) || !isPlainObject(request.query)) return null
  const allRoutes = flattenRoutes(routes)
  if (request.system === 'mom') {
    if (request.routeName) {
      const matchedByName = allRoutes.find(route => route.name === request.routeName)
      return matchedByName
        ? copyNavigationData(request, { name: matchedByName.name })
        : null
    }
    const targetPath = normalizePath(request.path)
    const matchedByPath = targetPath && allRoutes.find(route => normalizePath(route.path) === targetPath)
    return matchedByPath
      ? copyNavigationData(request, { path: matchedByPath.path })
      : null
  }
  if (request.system === 'mom-vue3') {
    const targetPath = normalizePath(request.path)
    const matchedMenu = targetPath && allRoutes.find(route => {
      return normalizePath(route.meta && route.meta.outerLink) === targetPath
    })
    return matchedMenu && matchedMenu.name
      ? copyNavigationData(request, { name: matchedMenu.name })
      : null
  }
  return null
}

export function getUnexpectedNavigationError (result) {
  if (!result || typeof result !== 'object' || typeof result.message !== 'string') {
    return null
  }
  return result.name === 'NavigationDuplicated' ? null : result
}
